import {
  PraksisstedprofilAdresseDto as UHPraksisstedprofilAdresseDto,
  PraksisstedprofilDto as UHPraksisstedprofilDto,
} from '../../api/generated/studiested-generated-api';
import {
  PraksisstedprofilAdresseDto as PSPraksisstedprofilAdresseDto,
  PraksisstedprofilDto as PSPraksisstedprofilDto,
} from '../../api/generated/praksissted-generated-api';

type PraksisstedprofilAdresse =
  | UHPraksisstedprofilAdresseDto
  | PSPraksisstedprofilAdresseDto;
type Praksisstedprofil = UHPraksisstedprofilDto | PSPraksisstedprofilDto;

export const landnrToNumber = (
  landnr: string | undefined,
): number | undefined =>
  landnr ? parseInt(landnr.replace('+', '')) : undefined;

type Adresse = {
  adresselinje1: string;
  adresselinje2: string;
  postnr: string;
  poststed: string;
};

// Only used in compile time
type AdresseTypeKeys = {
  [K in Required<keyof Adresse>]: '';
};

// Needed for runtime
const adresseTypeKeyObject: AdresseTypeKeys = {
  adresselinje1: '',
  adresselinje2: '',
  postnr: '',
  poststed: '',
};

const adresseTypeKeys = Object.keys(adresseTypeKeyObject);

const reduceToAdresse = (
  adresse: PraksisstedprofilAdresse | undefined,
): Adresse =>
  adresse
    ? Object.entries(adresse).reduce((acc: Adresse, [key, value]) => {
        if (adresseTypeKeys.includes(key)) {
          return { ...acc, [key]: (value as string) || '' };
        }

        return acc;
      }, adresseTypeKeyObject)
    : adresseTypeKeyObject;

export type EditProfilType = {
  navn: string;
  orgnr: string;
  adresse: Adresse;
  epost: string;
  telefonlandnr: string;
  telefonnummer: string;
};

// Only used in compile time
type EditProfilTypeKeys = {
  [K in Required<keyof EditProfilType>]: '' | Adresse;
};

// Needed for runtime
const editProfilTypeKeyObject: EditProfilTypeKeys = {
  navn: '',
  orgnr: '',
  adresse: {
    adresselinje1: '',
    adresselinje2: '',
    postnr: '',
    poststed: '',
  },
  epost: '',
  telefonlandnr: '',
  telefonnummer: '',
};

const editProfilTypeKeys = Object.keys(editProfilTypeKeyObject);

export const reduceToEditProfilType = (
  data: Praksisstedprofil,
): EditProfilType =>
  Object.entries(data).reduce((acc: EditProfilType, [key, value]) => {
    if (editProfilTypeKeys.includes(key)) {
      return {
        ...acc,
        [key]:
          key === 'adresse'
            ? reduceToAdresse(value as PraksisstedprofilAdresse | undefined)
            : (value as string) || '',
      };
    }

    return acc;
  }, editProfilTypeKeyObject as EditProfilType);
